<template>
    <app-layout title="Rechten">
        <template #header>
            <page-title :title="'Rechten - ' + permission .name" />
        </template>

        <template #pageContent>

        <div class="text-center" v-if="permission.deleted_at">
            <Button
                buttonClass="redo"
                title="Recht herstellen"
                text="Recht herstellen"
                @click="restoreRole"
            />
        </div>
        <div class="text-center" v-else>
            <Button
                htmlType="a"
                buttonClass="edit"
                title="Recht wijzigen"
                text="Recht wijzigen"
                :href="route('admin.permissions.edit', {'id':permission.id})"
            />
            <Button
                buttonClass="delete"
                title="Recht verwijderen"
                text="Recht verwijderen"
                @click="deleteRole"
            />
        </div>
        <div id="info" class="border-solid border border-slate-300 rounded m-4">
            <div class="border-solid border-b border-slate-300 bg-gray-100">
                <p class="pt-2 pl-2">Algemene informatie</p>
            </div>
            <div class="mt-1">
                <div class="m-4">
                    <div class="flex">
                        <p class="w-1/4 text-left font-bold">Recht ID</p>
                        <p class="w-3/4 text-left">{{ permission.id }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Naam</p>
                        <p class="w-3/4 text-left">{{ permission.name }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Omschrijving</p>
                        <p class="w-3/4 text-left">{{ permission.description }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Slug</p>
                        <p class="w-3/4 text-left">{{ permission.slug }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Los toekenbaar</p>
                        <p class="w-3/4 text-left">{{ permission.assignable }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Aangemaakt op</p>
                        <p class="w-3/4 text-left">{{ moment(permission.created_at).format('DD/MM/YYYY HH:mm') }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Gewijzigd op</p>
                        <p class="w-3/4 text-left">{{ moment(permission.updated_at).format('DD/MM/YYYY HH:mm') }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div id="permissions" class="border-solid border border-slate-300 rounded m-4">
            <div class="border-solid border-b border-slate-300 bg-gray-100">
                <p class="pt-2 pl-2">Rollen</p>
            </div>
            <div class="m-4">
                <div class="flex">
                    <div class="w-3/4">
                        <template v-for="role in permission.roles">
                            <badge :text="role.name" badgeClass="light" class="text-sm"/>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Td from '@/Components/Td.vue'
import Th from '@/Components/Th.vue'
import Button from '@/Components/Button.vue'
import Modal from '@/Components/Modal.vue'
import Input from '@/Components/Input.vue'
import Badge from '@/Components/Badge.vue'
import Select from '@/Components/Select.vue'
import Form from '@/Components/Form.vue'

import { Link } from '@inertiajs/inertia-vue3';
import store from '@/store'
import moment from "moment";
import { Inertia } from "@inertiajs/inertia"

export default {
    components: {
        AppLayout,
        PageTitle,
        Link, Table,
        Td,
        Th,
        Button,
        Modal,
        Input,
        Badge,
        Select,
        Form
    },
    props:[
        'permission'
    ],
    data() {
        return {}
    },
    setup (props){
        function deleteRole(){
            if(confirm('Recht \'' + props.permission.name + '\' wissen?')){
                Inertia.delete('/admin/permissions/' + props.permission.id)
            }
        }
        function restoreRole(){
            if(confirm('Recht \'' + props.permission.name + '\' herstellen?')){
                Inertia.put('/admin/permissions/' + props.permission.id + '/restore')
            }
        }
        return {
            state: store.state,
            ...store,
            deleteRole,
            restoreRole
        }
    },
    created: function () {
        this.moment = moment;
    },
    computed: {
    },
}

</script>
